// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falFaceMeh: CreateIconOptions = {
  "displayName": "FALFaceMeh",
  "viewBox": "0, 0, 512, 512",
  "d": "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"
};
